import React, { Component } from 'react';
import { getClass } from '../../../../utils/component-helpers';

import analyticService from 'services/analytics';
import { session } from 'services/session';

import Constants from '../../../../app.constants';
import NavItem from './nav-item';

import hamburgerIcon from '../../../../images/icons/hamburger-white-on-blue.svg';
import narrativLogo from '../../../../images/logos/narrativ_icon_4.png';
import './nav-sidebar.scss';

class NavSidebar extends Component {
	constructor(props) {
		super(props);

		this.Session = session;
		this.AnalyticService = analyticService;

		const adminMenu = [
			{
				label: 'Home',
				path: '/dashboard',
			},
			{
				label: 'Bid Center',
				path: '/bid-center',
				subnav: [
					{label: 'Merchant Overview V2', path: '/merch-ed-overview'},
					{label: 'Publisher Overview', path: '/publisher-overview'},
					{label: 'Merchant Auction Config', path: '/auction-config'},
					{label: 'Auction Config', path: '/auction-config-editor'},
					{label: 'Bulk Match Page', path: '/bulk-match'},
				],
			},
			{
				label: 'Product Match',
				path: '/product-match',
				subnav: [
					{label: 'Smartlink Search', path: '/smartlink-search'},
					{label: 'New Product', path: '/new-product'},
					{label: 'Affiliates', path: '/affiliates'},
					{label: 'LinkMate Domains', path: '/linkmate-domains'},
				],
			},
			{
				label: 'Smartlink Management',
				path: '/smartlinks/editor',
			},
			{
				label: 'Accounts',
				path: '/accounts',
				subnav: [
					{label: 'Accounts', path: '/'},
					{label: 'Scrapers', path: '/scrapers'},
					{label: 'Trackers', path: '/trackers'},
					{label: 'Narrativ Network', path: '/merchant-network'},
					{label: 'Widgets', path: '/widgets'},
				],
			},
			{
				label: 'Collections',
				path: '/collections',
				subnav: [
					{label: 'Collections', path: '/'},
					{label: 'Create Collection', path: '/create-collection'},
				],
				featureToggle: true,
			},
		];

		const productMatchMenu = [
			{
				label: 'Product Match',
				path: '/product-match',
				subnav: [
					{label: 'Smartlink Search', path: '/smartlink-search'},
					{label: 'New Product', path: '/manual-products/new'},
					{label: 'LinkMate Domains', path: '/linkmate-domains'},
				],
			},
		];

		const merchantMenu = [
			{
				label: 'Home',
				path: '/desk',
			},
			{
				label: 'Competitive Research',
				path: '/article-search',
				subnav: [
					{label: 'Keywords', path: '/keyword'},
					{label: 'Brands', path: '/brand'},
					{label: 'Products', path: '/product'},
				],
				featureToggle: true,
			},
			{
				label: 'Campaign Strategy',
				path: '/campaigns',
				subnav: [
					{label: 'Launch New', path: '/new'},
					{label: 'Optimize', path: '/optimize'},
				],
				hiddenForAllSites: true,
				featureToggle: true,
			},
			{
				label: 'Track Performance',
				path: '/megatables',
				subnav: [
					{label: 'Campaigns', path: '/campaign-performance'},
					{label: 'Stories', path: '/articles'},
					{label: 'Recommendations', path: '/recommendations'},
				],
			},
			// Budgets have been disabled until we determine if feature will be ported over to n-dash
			// or if we'll drop support entirely.
			/* {
				label: 'Budget',
				path: '/budgets',
				hiddenForAllSites: true,
			}, */
		];

		const publisherMenu = [
			{
				label: 'Home',
				path: '/dashboard',
			},
			{
				label: 'Build New Recommendations',
				path: '/new-recs',
				subnav: [
					{
						label: 'Rates and Strategies',
						path: '/rates',
						hiddenForAllSites: true,
					},
					{label: 'Product Research', path: '/product-research'},
					{label: 'Search Trends', path: '/search-trends'},
					{label: 'Smartshops', path: '/bam-box', hiddenForAllSites: true},
				],
			},
			{
				label: 'Update Recommendations',
				path: '/smartlinks/editor',
				hiddenForAllSites: true,
				featureToggle: true,
			},
			{
				label: 'Track Performance',
				path: '/megatables',
				subnav: [
					{label: 'Stories', path: '/articles'},
					{label: 'Recommendations', path: '/smartlinks'},
					{label: 'Merchants', path: '/merchants'},
					{label: 'Products Purchased', path: '/products'},
				],
			},
		];

		this.menuMap = {
			admin: adminMenu,
			product_match: productMatchMenu,
			publisher: publisherMenu,
			merchant: merchantMenu,
		};

		// Menu items only available to limited Orgs
		if (this.props.whitelistedOrgs.includes(session.orgId) || session.isAdmin) {
			const whitelistMenuMap = {
				publisher: [],
				merchant: [],
			};

			const whitelist = whitelistMenuMap[this.props.userRole];
			if (whitelist) this.menuMap[this.props.userRole].push(...whitelist);
		}

		const navItems = this.expandSubnavs(this.menuMap[this.props.userRole]);

		this.state = {
			// Bind to state so that component re-renders when this value updates
			navItems: navItems || [],
			orgPath: '',
		};
	}

	componentDidUpdate(prevProps) {
		if (prevProps.userRole !== this.props.userRole ||
			prevProps.location.pathname !== this.props.location.pathname) {
			this.setState({
				navItems: this.expandSubnavs(this.menuMap[this.props.userRole]),
			});
		}
	}

	expandSubnavs(navItems) {
		// Always expand all of the subnavs
		return navItems.map((item) => {
			item.subnavExpanded = true;
			return item;
		});
	}

	onSubnavItemClicked(event, navItem) {
		// Only send GA event if Megatable subnav clicked
		const subnavLabel = event.currentTarget.innerText;
		if (navItem.label === 'Insights') {
			this.AnalyticService.trackEvent(
				'Navigation Bar', 'Click', `${subnavLabel} Insights`
			);
		}

		event.stopPropagation();
		// Allow clicking directly on item or nearby it
		const path = event.target.getAttribute('data-path') || event.currentTarget.getAttribute('data-path');
		this.redirectToPath(path);
	}

	onNavItemClicked(navItem) {
		// We want to handle redirect in this component instead of NavItem
		this.AnalyticService.trackEvent('Navigation Bar', 'Click', navItem.label);

		if (!navItem.subnav) {
			this.redirectToPath(navItem.path);
		}
	}

	/* Helper functions */
	getOrgPath(userRole, pathname) {
		let orgPath;

		if (userRole === 'admin') {
			orgPath = 'admin';
		} else {
			// Need to escape '\' bc constructing RexExp from string
			// eslint-disable-next-line
			orgPath = pathname.match(new RegExp(`${userRole}\/\\d+`));
			// eslint-disable-next-line
			const noOrgIdRegex = new RegExp(`${userRole}\/\\D+`);
			orgPath = orgPath
				? orgPath[0]
				: noOrgIdRegex.test(pathname)
					? `${userRole}/${this.Session.orgId}`
					: '';
		}

		return orgPath;
	}

	redirectToPath(path) {
		const orgPath = this.getOrgPath(this.props.userRole, this.props.location.pathname);
		const isBestBuy = this.Session.userRole === 'merchants' && this.Session.orgId === 1125;
		const isStagingMerch = this.Session.userId === 233649 && ['staging', 'local'].includes(Constants.ENV);
		const isStagingPubTestUser = this.Session.userId === 233638 && ['staging', 'local'].includes(Constants.ENV);
		const isReleasePubTestUser = [2458, 2464].includes(session.userId) && ['release'].includes(Constants.ENV);

		// Consolidating special user access into a single boolean
		const isSpecialUser = isBestBuy || isStagingMerch || isStagingPubTestUser || isReleasePubTestUser;
		/*
		 * exposedPaths: v2 pages available to publishers or merchants
		 * implementedPaths: v2 pages only available to admins for QA purposes
		 */

		if (this.props.exposedPaths.includes(path) ||
			(this.props.whitelistedPaths.includes(path) && this.props.whitelistedOrgs.includes(session.orgId)) ||
			(this.props.implementedPaths.includes(path) && (this.props.isAdmin || isSpecialUser))) {
			this.props.history.push(`/v2/${orgPath}${path}`);
		} else {
			window.location = `/#/${orgPath}${path}`;
		}
	}

	toggleFeature() {
		session.update({isAdminView: !session.isAdminView});
		this.props.toggleAdminView();
	}

	render() {
		const header = (
			<div className="header">
				<div className="hamburger" onClick={this.props.toggleNavSidebar}>
					<img src={hamburgerIcon} alt="Expand/collapse nav" />
				</div>
				<a className="logo" href="/v2/">
					<img src={narrativLogo} alt="Narrativ" />
				</a>
			</div>
		);

		const featureToggle = session.isAdmin ? (
			<div className="feature-toggle" onClick={() => this.toggleFeature()}>
				{this.props.isAdminView ? 'Seeing new features' : `Seeing what ${this.props.userRole}s see`}
			</div>
		) : null;

		const isBestBuy = this.Session.userRole === 'merchants' && this.Session.orgId === 1125;
		const isStagingMerch = this.Session.userId === 233649 && ['staging', 'local'].includes(Constants.ENV);
		const isStagingPubTestUser = this.Session.userId === 233638 && ['staging', 'local'].includes(Constants.ENV);
		const isReleasePubTestUser = [2458, 2464].includes(session.userId) && ['release'].includes(Constants.ENV);
		const isPubTestUser = isStagingPubTestUser || isReleasePubTestUser;

		const navItems = this.state.navItems
			// Exclude navItems when viewing allSites
			.filter((navItem) => !(session.allSites && navItem.hiddenForAllSites))
			// Exclude navItems under feature toggle except BestBuy/StagingMerch for AS and BC, PubFlagUser for NRP
			.filter((navItem) => !(navItem.featureToggle
				&& !(session.isAdminView && session.merchPricingModel !== 'CPA'))
				|| ((isBestBuy || isStagingMerch) && ['/article-search', '/campaigns'].includes(navItem.path))
				|| (isPubTestUser && ['/new-recs'].includes(navItem.path)))
			.map((navItem, index) => {
				return (
					<NavItem
						item={navItem}
						key={index}
						currentPath={this.props.location.pathname}
						onNavItemClicked={() => this.onNavItemClicked(navItem)}
						onSubnavItemClicked={(event) => this.onSubnavItemClicked(event, navItem)}>
					</NavItem>
				);
			});

		return (
			<div className={getClass(
				'nav-sidebar',
				{'hidden': this.props.navSidebarCollapsed}
			)}>
				{header}
				<ul>
					{navItems}
				</ul>
				{featureToggle}
			</div>
		);
	}
}

export default NavSidebar;
